module.exports = __webpack_public_path__ + "media/src/StayPackage/images/person-7925f3434933afee010ab091322fd89c.svg";